var exports = {
  "V": "FooterSection__In9sgb",
  "Z": "FooterSection__Spacer__f3A-91",
};

module.exports = exports;
